// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bid-input-buttons[data-v-7aad8e53]{align-items:center;display:flex;flex-wrap:nowrap;gap:.5rem;min-width:220px}.bid-input-buttons__button[data-v-7aad8e53]{aspect-ratio:1;flex:1 0 2.5em;font-size:1.125em;font-weight:700;line-height:1;padding:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
